//* Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

//* Add the Web App's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCNrQFAaj5-RyHz5EDMl4oliCsxeQGrkfc",
  authDomain: "gubee-96ed9.firebaseapp.com",
  projectId: "gubee-96ed9",
  storageBucket: "gubee-96ed9.firebasestorage.app",
  messagingSenderId: "112349233630",
  appId: "1:112349233630:web:fdb692ec8d6840625d1d4f",
  measurementId: "G-LX2T0YWCFW",
};

//* Initialize Firebase
let firebase_app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

//* Initialize Firebase Auth and set persistence
const auth = getAuth(firebase_app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Session persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Failed to set session persistence:", error);
  });

export { auth };
export default firebase_app;
